module.exports = __webpack_public_path__ + "img/pic-yellow.19b8ff07.png";